import { create } from 'zustand';

/**
 * État global « impression en cours ». Les graphiques s'y abonnent pour basculer
 * en dimensions fixes pendant l'impression : Recharts calcule alors ses tailles
 * statiquement, sans ResizeObserver (lequel mesure 0 au moment du snapshot
 * d'impression, laissant les cards vides).
 */
type PrintModeStore = {
  isPrinting: boolean;
  setPrinting: (value: boolean) => void;
};

export const usePrintMode = create<PrintModeStore>((set) => ({
  isPrinting: false,
  setPrinting: (value) => set({ isPrinting: value }),
}));
